const ExpirationMaintenance = Object.freeze({
    EXPIRED: {
        name: 'Просроченные',
        value: 'EXPIRED',
    },
    NOT_EXPIRED: {
        name: 'Непросроченные',
        value: 'NOT_EXPIRED',
    },
    ALL: {
        name: 'Все',
        value: 'ALL',
    },
});

export { ExpirationMaintenance };
